/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Moderate_MembersInputs */



/**
* | output |
* | --- |
* | "Time out members" |
*
* @param {Leveling_Perm_Moderate_MembersInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_moderate_members = /** @type {((inputs?: Leveling_Perm_Moderate_MembersInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Moderate_MembersInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отправлять участников в тайм-аут")
	return /** @type {LocalizedString} */ ("Time out members")
});